import React from 'react';
import { Polygon, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

export interface Star6MarkerProps {
    key: string;
    color: string;
    position: any;
    radius: number;
    fteDVMs: number;
    opacity: number;
    name: string;
    showTooltip: boolean;
    isAnimated: boolean;
    onClick?: (event: any) => void;
}

export const Star6Marker = (props: Star6MarkerProps) => {
    const latFactor = 1 / 110540;
    const lngFactor =
        1 / (111320 * Math.cos((props.position[0] * Math.PI) / 180));
    const outerRadiusLat = props.radius * latFactor;
    const outerRadiusLng = props.radius * lngFactor;
    const innerRadiusLat = outerRadiusLat * 0.5;
    const innerRadiusLng = outerRadiusLng * 0.5;
    const angleOffset = Math.PI / 6;

    const points = [];

    for (let i = 0; i < 12; i++) {
        const angle = (Math.PI / 6) * i - angleOffset;
        const rLat = i % 2 === 0 ? outerRadiusLat : innerRadiusLat;
        const rLng = i % 2 === 0 ? outerRadiusLng : innerRadiusLng;
        points.push([
            props.position[0] + rLat * Math.sin(angle),
            props.position[1] + rLng * Math.cos(angle),
        ]);
    }
    const handleClick = (event: any) => {
        if (props.onClick) {
            props.onClick(event);
        }
    };

    return (
        <Polygon
            pane="markerPane"
            eventHandlers={{
                click: handleClick,
            }}
            key={`${props.key}-${props.opacity}`}
            positions={points}
            color="transparent"
            weight={0}
            fillColor={props.color}
            fillOpacity={props.opacity}>
            {!props.isAnimated && props.showTooltip && (
                <Tooltip direction="top">
                    FTE DVMs: {props.fteDVMs} | Type: {props.name}
                </Tooltip>
            )}
        </Polygon>
    );
};
